import { useRouter } from "next/router"
import classNames from "classnames"

import { useCountry } from "lib/country"
import { useTranslation } from "lib/i18n/translation"
import { getFrom } from "lib/redirects"

import SkeletonLink from "components/common/skeleton-link"

export const NavOffers = ({ }) => {
	const { svodAvailable } = useCountry()

	if (!svodAvailable) {
		return null
	}

	const router = useRouter()
	const currentRoute = getFrom(router ? router.route : "/")
	const { c } = useTranslation()

	return <nav className="switch" aria-label={c("offers-navigation")}>
		<SkeletonLink href="/ways-to-watch/film-by-film" >
			<a
				href="#"
				title={c("header-single")}
				className={classNames("icon-ticket", { active: !currentRoute.includes("/subscription")})}
			>
				{c("header-single")}
			</a>
		</SkeletonLink>
		<SkeletonLink href="/ways-to-watch/subscription" >
			<a
				href="#"
				title={c("renew-for")}
				className={classNames("icon-selection-alt", { active: currentRoute.includes("/subscription") })}
			>
				{c("renew-for")}
			</a>
		</SkeletonLink>
	</nav>
}
